import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";

import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';
import Element from '../components/Element.js';

import { apiSearchElements } from '../api.js';
import ElementFormSearch from '../components/ElementFormSearch.js';

const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiTheatra = `${protocole}${host}:${port}`


const Page = styled.div`
position:relative;
min-height:100vh;
overflow-y: scroll;
padding-bottom:300px;
`
const Resultat = styled.div`
float:left;
margin: 10px;
width: 100%;
`
const Titre = styled.h2`
margin:5px auto;
`
const Titre2 = styled.h3`
margin:10px auto;
`

const PageElementsSearch = () => {
    const {typeElement,limit, index} = useParams()


    const [elements, setElements] = useState(null)
    const [critere, setCritere] = useState(null)
    const [typeDocument, setTypeDocument] = useState(null)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {
        apiSearchElements(typeElement, critere, typeDocument, limit, index)
        .then(res => {
            setElements(res.reponse.rows)
            setTotal(res.reponse.count)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setElements([])
            setTotal(0)
            setLoading(false)
            setErreur(true)
        })
    }, [typeElement, critere, typeDocument, limit, index])

    const onSubmit = (element) => {

        //console.log("Recherche")
        //console.log(element)
        const {critere, typeDocument} = element
        //alert("Recherche " + critere  + " " + typeDocument)
        setTypeDocument(typeDocument)
        setCritere(critere)
        setTotal(0)
        setElements(null)
        setLoading(true)

        const headers = {
            'accept': 'application/json',
        }

        axios({
            //method post au lieu de put pour le file upload...
            method: 'post',
            headers: headers,
            url:  `${apiTheatra}/${typeElement}/limit/${limit}/index/${index}`,
            data:  {
                critere: critere,
                typeDocument: typeDocument
            }
        })
        .then((res) => {
            setLoading(false)
            if (res.status === 200) {
                //alert("Recherche " + typeElement);
                setTotal(res.data.count)
                setElements(res.data.rows)
            } else {
                Promise.reject()
            }
        })
        .catch((erreur) => {
            setErreur(true)
            alert("Une erreur a eu lieu lors de la modification"
            + " de l'element de type "
            + typeElement
            + " Erreur : "
            + erreur.message)
        })
    }

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Titre>{typeElement} IGLS</Titre>
            <ElementFormSearch
                initialValues=''
                typeElement={typeElement}
                onSubmit={onSubmit}
            />
            <Resultat>
            {! loading  && ! erreur && <Titre2>{typeElement} (au nombre total de {total})</Titre2> }
            {! loading  && elements && elements.map(element => <Element key={element.id} type ={typeElement} elem={element} liste={true}/>)}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }
            </Resultat>
            <Footer/>
        </Page>
    )
}
export default PageElementsSearch